import React from 'react';

const Copyright = ({ copyrightText }) => {
  const year = new Date().getFullYear();
  const text = `${year} ${copyrightText}`;
  return (
    <p className="ft-corporate__copyright">&copy; {text}</p>
  );
};

export default Copyright;
